import { ReactNode } from 'react';
import { PortalHeader } from '../portal/PortalHeader';
import { LiveAnnouncer } from '../ui/live-announcer';

interface AdminShellProps {
    children: ReactNode;
}

export function AdminShell({ children }: AdminShellProps) {
    return (
        <div className="min-h-screen bg-admin-app">
            <a
                href="#main-content"
                onClick={(event) => {
                    event.preventDefault();
                    document.getElementById('main-content')?.focus();
                }}
                className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-2 focus:z-[60] focus:rounded-md focus:bg-white focus:px-3 focus:py-2 focus:text-sm focus:font-medium focus:text-neutral-900 focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring"
            >
                Skip to main content
            </a>
            <PortalHeader />
            <main
                id="main-content"
                tabIndex={-1}
                className="mx-auto w-full max-w-screen-2xl px-4 py-6 focus:outline-none sm:px-6 lg:px-8"
            >
                {children}
            </main>
            <LiveAnnouncer />
        </div>
    );
}
